import { END_POINTS } from '../helpers';
import { CommonBody, Listing, ListingById } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export interface GetListingsResponses {
  count: number;
  data: Listing[];
  approvedCount: number;
  pendingCount: number;
  rejectCount: number;
}

type GetListingsResponse = {
  approvedCount: number;
  count: number;
  pendingCount: number;
  rejectCount: number;
  user: Listing[];
};

interface RatingResponse {
  data: SingleRating[];
  count: number;
}

export interface SingleRating {
  _id: string;
  rating: number;
  review: string;
  phoneNo: string;
  dialCode: string;
  name: string;
}

export const listingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getListings: builder.query<
      CommonResponse & { data: GetListingsResponse },
      {
        page: number;
        limit: number;
        search: string;
        role: number;
        status?: number;
      }
    >({
      query: ({ page, limit, search, role, status }) => ({
        url: `${END_POINTS.getListing}?page=${page}&limit=${limit}&role=${role}${
          status ? `&status=${status}` : ''
        }${search?.length ? `&search=${search}` : ''}`,
        method: 'GET',
      }),
    }),
    addListing: builder.mutation<CommonResponseType & { data: any }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addListing}`,
        method: 'POST',
        body,
      }),
    }),
    updateListing: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateListing}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    updateListingDetails: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateListingDetails}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    getListingById: builder.query<CommonResponse & { data: ListingById }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getListingById}/${id}`,
        method: 'GET',
      }),
    }),

    deleteListing: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteListing}/${id}`,
        method: 'DELETE',
      }),
    }),
    getAddListing: builder.query<
      CommonResponse & { data: GetListingsResponses },
      { page: number; limit: number; id?: string; role?: number }
    >({
      query: ({ page, limit, id, role }) => ({
        url: `${END_POINTS.getAddListing}?page=${page}&limit=${limit}&${id ? `sellerId=${id}` : ''}&${role ? `role=${role}` : ''}`,
        method: 'GET',
      }),
    }),
    getUserRating: builder.query<CommonResponseType & { data: RatingResponse }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getUserRating}/${id}?page=${1}&limit=${10}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetListingsQuery,
  useUpdateListingMutation,
  useLazyGetListingByIdQuery,
  useLazyDeleteListingQuery,
  useAddListingMutation,
  useUpdateListingDetailsMutation,
  useLazyGetAddListingQuery,
  useLazyGetUserRatingQuery,
} = listingApi;
